import { graphql } from 'gatsby';
import { GetCurrentInterestRateDetailsFragment as GetCurrentInterestRateDetailsFragmentType } from 'graphqlTypes';

export const BaseInterestRateDetails = graphql`
  fragment BaseInterestRateDetails on ContentfulSpendingCardInterestRateDetails {
    apy
    interestRate
    effectiveDate
  }
`;

// Contentful currently does not support "singleton" models,
// which means that we can't create a model that only accepts
// one record. While in other instances (such as category ordering)
// we created one record, given the importance of showing the correct
// value for interest rates, I have added a "referenceId" field that
// will be used to query for a specific Contentful interest rate record.

export const GetCurrentInterestRateDetailsFragment = graphql`
  fragment GetCurrentInterestRateDetails on Query {
    contentfulSpendingCardInterestRateDetails(
      referenceId: { eq: "c4c1a482-7ea2-42c0-a118-02f815e4829a" }
    ) {
      ...BaseInterestRateDetails
    }
  }
`;

export const getCurrentInterestRateDetails = (
  data: GetCurrentInterestRateDetailsFragmentType,
) => {
  const defaultRate = 0;

  const apy =
    data.contentfulSpendingCardInterestRateDetails?.apy || defaultRate;
  const interestRate =
    data.contentfulSpendingCardInterestRateDetails?.interestRate || defaultRate;

  return {
    apy,
    formattedApy: `${apy}%`,
    interestRate,
    formattedInterestRate: `${interestRate}%`,
    effectiveDate:
      data.contentfulSpendingCardInterestRateDetails?.effectiveDate,
  };
};
